import { render, staticRenderFns } from "./TabInspiration.vue?vue&type=template&id=55d29896&"
import script from "./TabInspiration.vue?vue&type=script&lang=js&"
export * from "./TabInspiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports